<app-container-transparent>
    <div fxLayout="row" style="margin-bottom: 50px; padding: 10px;">
        <div fxFlex="95">
            <p style="font-size: 18px; color: #646464;">MFG - Utilizamos esse filtro para selecionar as melhores vagas para você. Abaixo estão as configurações do seu MFG</p>
        </div>
        <div fxFlex="5">
            <a mat-button routerLink="/hao" style="float: right;" color="primary" mat-raised-button>
                <mat-icon>arrow_back</mat-icon>
                Voltar
            </a>
        </div>
    </div>

    <div fxLayout="row" *ngIf="loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <section *ngIf="!loading">
        <div flexLayout="row" class="main-painel">
            <div fxFlex="100">
                <mat-card>
                    <mat-card-title>(M) Mercado</mat-card-title>
                    <mat-card-content>{{ mfgModel.mercado }}</mat-card-content>
                </mat-card>
            </div>
            <div fxFlex="100">
                <mat-card>
                    <mat-card-title>(F) Função</mat-card-title>
                    <mat-card-content>{{ mfgModel.funcao }}</mat-card-content>
                </mat-card>
            </div>
            <div fxFlex="100">
                <mat-card>
                    <mat-card-title>(G) Geografia</mat-card-title>
                    <mat-card-content>{{ mfgModel.geografia }}</mat-card-content>
                </mat-card>
            </div>
        </div>
        <p style="font-size: 16px; margin-bottom: 20px; margin-top: 70px;color: #646464;">Há algo que você queira melhorar no seu MFG? Deixe suas contribuições abaixo:</p>
        <div flexLayout="row">
            <div fxFlex="50">

                <div *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
                <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div>

                <div flexLayout="column" [formGroup]="formGroup">
                    <mat-form-field appearance="fill" style="width: 100%; background-color: #ffffff;">
                        <!--<mat-label>Leave a comment</mat-label>-->
                        <textarea formControlName="contribuicao" rows="6" matInput placeholder=""></textarea>
                    </mat-form-field>

                    <button (click)="enviarMensagem()" [disabled]="isSending" style="float: right; margin-top: 20px;" color="primary" mat-raised-button>
                        <mat-icon>email</mat-icon>
                        Enviar contribuições
                    </button>
                </div>
            </div>
            <div fxFlex="50">

            </div>
        </div>
    </section>
</app-container-transparent>
